var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"online-service"},[_c('iframe',{attrs:{"height":"100%","width":"100%","src":"https://hqxcxzfc.qiyukf.com/client?k=25bbb36de4d552ce8dbda2423fafd194&wp=1&robotShuntSwitch=0&gid=583010284&language=zh-cn&templateId=8132161","frameborder":"0"}})])
}]

export { render, staticRenderFns }